import { useCallback, useState } from "react";

import { UseAccountCashPanelReturn } from "./types";

// Thinner than `useHoldingTradePanel` on purpose: one entry point, no per-row position to remember.
export const useAccountCashPanel = (): UseAccountCashPanelReturn => {
  const [panel, setPanel] = useState({ isOpen: false });

  const openPanel = useCallback(() => setPanel({ isOpen: true }), []);
  const closePanel = useCallback(() => setPanel({ isOpen: false }), []);

  return { panel, openPanel, closePanel };
};
